<!--
 * @Descripttion: 流程草稿列表
 * @Author: jschen
 * @Date: 2021-09-05 14:28:12
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-25 16:02:54
-->
<template>
    <div v-show="visible" class="right-box">
        <div class="search-container">
            <div class="search-row">
                <!-- <div class="title-item">
                    <el-input
                        v-model="searchDraftOpt.title"
                        placeholder="标题关键字搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    >
                    </el-input>
                </div> -->
                <div class="date-item draft-date">
                    <span>接收时间</span>
                    <div class="block">
                        <el-date-picker
                            v-model="searchDraftOpt.date"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            @change="datePicker"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div class="search-btn-group">
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                </div>
            </div>
        </div>
        <div class="sort-box">
            <div class="sort-title">
                <span>{{ title }}列表</span>
            </div>
            <div class="search-right-box">
                <div class="sort-right-box">
                    <el-button plain size="mini" @click="refresh">刷新</el-button>
                </div>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="draftRecords"
            size="mini"
            border
            style="width: 100%"
            height="calc(100% - 145px)"
            @row-click="rowDraftClick"
        >
            <el-table-column label="序号" width="55" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="title" label="标题" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column prop="templateName" label="模板名称" align="center" width="150"> </el-table-column>
            <el-table-column prop="createDate" sortable label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
            </el-table-column>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                :current-page="searchDraftOpt.current"
                :page-sizes="[20, 50]"
                :page-size="searchDraftOpt.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchDraftOpt.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { findByDraft } from "@/api";
import _ from "lodash";
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            draftRecords: [],
            searchDraftOpt: {
                title: "", // 标题
                date: "",
                current: 1,
                size: 20,
                total: 0,
            },
        };
    },
    methods: {
        search() {
            this.searchDraftOpt.current = 1;
            this.loadData();
        },
        loadData() {
            this.findByDraft();
        },
        // 查询流程草稿列表
        async findByDraft() {
            this.loading = true;
            try {
                const { body, code, message } = await findByDraft({
                    ..._.omit(this.searchDraftOpt, ["date", "total"]),
                });
                if (code === "0000") {
                    const { current, records, total } = body;
                    this.draftRecords = records;
                    this.searchDraftOpt.total = total;
                    this.searchDraftOpt.current = current;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        // 刷新
        refresh() {
            this.reset();
        },
        clearKw() {
            this.searchDraftOpt = {
                title: "", // 标题
                date: "",
                current: 1,
                size: 20,
                total: 0,
            };
        },
        reset() {
            this.searchDraftOpt = {
                title: "", // 标题
                date: "",
                current: 1,
                size: 20,
                total: 0,
            };
            this.loadData();
        },
        datePicker(dateArr) {
            const [startDate, endDate] = dateArr;
            this.searchDraftOpt.startDate = startDate;
            this.searchDraftOpt.endDate = endDate;
        },
        rowDraftClick(row) {
            this.handleRouterJump(1, row.draftUrl, "", true);
        },
        handleSizeChange(val) {
            this.searchDraftOpt.current = 1;
            this.searchDraftOpt.size = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.searchDraftOpt.current = val;
            this.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
.draft-date {
    margin-left: 0 !important;
}
</style>
